import * as Yup from "yup";
export default Yup.object().shape({
  // property_number: Yup.string()
  //   .typeError("Required")
  //   .min(2, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // serial_number: Yup.string()
  //   .typeError("Required")
  //   .min(2, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // arrears: Yup.string()
  //   .typeError("Required")
  //   .matches(/^[0-9]+$/, "Arrears must be a number")
  //   .required("Required"),
  receipt_number: Yup.string()
    .typeError("Required")
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  bank: Yup.string()
    .typeError("Required")
    .min(1, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  branch: Yup.string()
    .typeError("Required")
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  // year: Yup.string()
  //   .typeError("Required")
  //   .min(1, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // issue_date: Yup.string()
  //   .typeError("Required")
  //   .min(1, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required"),
  // due_date: Yup.string()
  //   .typeError("Required")
  //   .min(1, "Too Short!")
  //   .max(50, "Too Long!")
  //   .required("Required")
  //   .when("issue_date", (issue_date) => {
  //     if (issue_date) {
  //       return Yup.date()
  //         .min(issue_date, "Due Date must be after Issue Date")
  //         .typeError("Due Date is required");
  //     }
  //   }),
  payment_date: Yup.string()
    .typeError("Required")
    .min(1, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),

  // paid_amount: Yup.string()
  //   .typeError("Required")
  //   .matches(/^[0-9]+$/, "Only Digits Are Allowed")
  //   .min(1, "Too Short!")
  //   .max(2147483647, "Too Long!")
  //   .required("Required"),
  // remaining_amount: Yup.string().typeError("Required").required("Required"),
  remarks: Yup.string()
    .typeError("Required")
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

// owner_name: data?.property_owners[0]?.name,
//                 property_number: data?.data?.property_number,
//                 serial_number: data?.data?.serial_number,
//                 arrears: data?.data?.arrears,

//                 reciept_number: data?.data?.tax_collection?.reciept_number,
//                 issue_date: moment(data?.data?.tax_collection?.reciept_number),
//                 due_date: moment(data?.data?.tax_collection?.reciept_number),
//                 payment_date: moment(data?.data?.tax_collection?.reciept_number),
//                 year: moment(data?.data?.tax_collection?.reciept_number),
//                 bank: data?.data?.tax_collection?.bank,
//                 branch: data?.data?.tax_collection?.branch,
//                 paid_ammount: data?.data?.tax_collection?.paid_ammount,
//                 remaining_amount: data?.data?.tax_collection?.remaining_amount,
//                 payment: data?.data?.tax_collection?.payment,
//                 remarks: data?.data?.tax_collection?.remarks,

//                 current_year_tax: data?.data?.atv?.annual_tax,
